/**
 * CacheManagementPage - Cache performance and invalidation management
 *
 * Surfaces CachePerformanceDashboard and CacheInvalidationManager from @ferp/workflow-forms.
 * Provides visibility into Apollo Client cache, Valkey cache, and invalidation patterns.
 *
 * Route: /admin/cache-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon, Tabs } from '@mantine/core';
import { IconDatabase, IconRefresh, IconChartBar } from '@tabler/icons-react';

import { CachePerformanceDashboard, CacheInvalidationManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function CacheManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconDatabase size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Cache Management</Title>
            <Text size="sm" c="dimmed">
              Cache performance monitoring and targeted invalidation
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <Tabs defaultValue="performance">
        <Tabs.List mb="md">
          <Tabs.Tab value="performance" leftSection={<IconChartBar size={16} />}>
            Performance
          </Tabs.Tab>
          <Tabs.Tab value="invalidation" leftSection={<IconRefresh size={16} />}>
            Invalidation
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="performance">
          <CachePerformanceDashboard />
        </Tabs.Panel>

        <Tabs.Panel value="invalidation">
          <CacheInvalidationManager
            onClose={() => {}}
            onInvalidate={() => {
              // Refresh the page or show success notification
            }}
          />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
}

export default CacheManagementPage;
